<template>
  <Grid gtc="137px 1fr" gap="var(--r-space-md)" class="box1">
    <div class="chart">
      <HighChart v-if="chartOptions" :options="chartOptions" />
    </div>

    <Grid gtr="repeat(3, 1fr)" gap="14px">
      <ChartInfo color="#464159" title="Received prices" :amount="data ? data.received_prices_count : 0" />
      <ChartInfo color="#6C7B95" title="Forecasted prices" :amount="data ? data.forecasted_prices_count : 0" />
      <ChartInfo color="#8BBABB" title="Missing prices" :amount="data ? data.missing_prices_count : 0" type="left" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { Chart as HighChart } from 'highcharts-vue'
// Components
import ChartInfo from './ChartInfo'

export default {
  components: {
    HighChart,
    ChartInfo
  },

  props: {
    data: {
      required: true
    }
  },

  computed: {
    chartOptions() {
      if (!this.data) return null

      const missingPrices = this.data.missing_prices_count
      const receivedPrices = this.data.received_prices_count
      const forecastedPrices = this.data.forecasted_prices_count

      return {
        credits: { enabled: false },
        tooltip: { enabled: false },
        title: {
          text: `
              <span class="text-subtitle-2 text-secondary-1">${missingPrices}</span>
              <br>
              <span class="text-secondary-1 text-caption-1">Missing prices</span>
          `,
          align: 'center',
          verticalAlign: 'middle'
        },

        chart: {
          title: false,
          width: 137,
          height: 137,
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          },
          pie: {
            size: 137
          }
        },
        series: [
          {
            innerSize: '80%',
            type: 'pie',
            enableMouseTracking: false,
            data: [
              { y: missingPrices, color: '#8BBABB' },
              { y: receivedPrices, color: '#464159' },
              { y: forecastedPrices, color: '#6C7B95' }
            ]
          }
        ]
      }
    }
  }
}
</script>
